import { render } from "./MetricList.vue?vue&type=template&id=1028a833&scoped=true"
import script from "./MetricList.vue?vue&type=script&lang=js"
export * from "./MetricList.vue?vue&type=script&lang=js"

import "./MetricList.vue?vue&type=style&index=0&id=1028a833&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1028a833"],['__file',"src/containers/widget/configs/MetricList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1028a833"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1028a833', __exports__)) {
    api.reload('1028a833', __exports__)
  }
  
  module.hot.accept("./MetricList.vue?vue&type=template&id=1028a833&scoped=true", () => {
    api.rerender('1028a833', render)
  })

}


export default __exports__